import React, { ReactNode } from 'react';

import styles from './CalendarEventDrawerHeader.module.scss';
import { EventDate } from './event-date/EventDate';

export type CalendarEventDrawerProps = {
  title: string;
  subtitle: string;
  dateString: string;
  logoNode?: ReactNode;
  reported?: boolean;
  companyEvent?: boolean;
};

export const CalendarEventDrawerHeader = ({
  title,
  subtitle,
  logoNode,
  dateString,
  reported,
  companyEvent,
}: CalendarEventDrawerProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.logoAndTitleWrapper}>
        <div className={styles.logoWrapper}>{logoNode}</div>
        <div className={styles.columnWrapper}>
          <div className={styles.titleWrapper} data-testid="event-name">{title}</div>
          <div className={styles.subtitleWrapper} data-testid="asset-ticker">
            {subtitle}
          </div>
        </div>
      </div>
      <EventDate
        dateString={dateString}
        reported={reported}
        companyEvent={companyEvent}
      />
    </div>
  );
};
